import sgPopupMixin from '@/mixins/sg-popup.mixin'
import { concealRule, reportRule, mapRule, signOutRule, reportDeferRule, bsDeferRule, jzDeferRule, privacyRule } from './rules'
import { Button } from 'vant'
export default {
	name: 'rulesPopup',
	mixins: [sgPopupMixin],
	components: {
		[Button.name]: Button,
	},
	props: {
		showType: {
			type: Number,
			default: 1,	// 1 隐私政策  2 惠企助年报助手服务协议  3 惠企助地图标注服务协议
		},
		time: {
			type: Number,
			default: 3
		},
		showAgree: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		renderContent() {
			const contentMap = {
				1: concealRule,
				2: reportRule,
				3: signOutRule,
				4: reportDeferRule,
				5: bsDeferRule,
				6: jzDeferRule,
				7: privacyRule
			}
			const rule = contentMap[this.showType]
			return [
				<div style="font-size: 18px;text-align: center;font-weight: 700;margin-bottom: 10px;">{rule.title}</div>,
				<div domPropsInnerHTML={rule.content} style="max-height: 70vh;overflow-x: hidden;overflow-y: auto;line-height: 18px;text-align: justify;margin-bottom: 10px;font-size: 12px;"></div>,
				// <div style="font-size:16px;height: 30px;line-height: 30px;" class="uc-btn blue" onClick={() => {
				// 	this.showPopup = false
				// }}>确认</div>
				// <van-button type="primary" class="uc-btn blue uc-btn-xy" onClick={() => {
				// 	this.showPopup = false
				// }} disabled={this.showAgree} >
				// 	{
				// 		this.showAgree ? <span>({this.time}s) </span> : ''
				// 	}
				// 	<span>确认</span>
				// </van-button >
				<van-button type="primary" class="uc-btn blue uc-btn-xy" onClick={() => {
					this.showPopup = false
				}} >

					<span>确认</span>
				</van-button >
			]
		},
	},
}

